export default {
  list: [{
    id: 1,
    model: 'KTM5',
    max: 120,
    sections: 1,
    idline: 1,
    count: 0,
    money: 0,
    idstop: 0,
    moved: true,
    enter: false,
    mode: 'to',
    price: 30,
    blocked: false,
    reverse: false,
    depot: true,
    color: 'red',
    loops: 0,
    types: [
      'red',
      'yellow',
      'blue'
    ]
  }]
}
